import { Routes } from '@angular/router';

import { routeData } from '@frontend/vanilla/core';

import { PokerClientDownloadComponent } from './poker-client-download.component';
import { PokerDownloadDeactivateGuard } from './poker-download-deactivate-guard';

export const pokerClientDownloadRoutes: Routes = [
    {
        path: '',
        component: PokerClientDownloadComponent,
        canActivate: [PokerDownloadDeactivateGuard],
        data: routeData({ allowAllWorkflowTypes: true, allowAuthorized: true }),
    },
];
